/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB',
      )
    },
    registered() {
      console.log('Service worker has been registered.')
    },
    cached() {
      // alert('service worker文件资源已更新，请稍后刷新以获取更优质的服务')
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated() {
      console.log('New content is available; please refresh.')
      popupWindow()
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}

function popupWindow() {
  console.log('资源有更新')
  // const div = document.createElement('div')
  // div.setAttribute(
  //   'style',
  //   `
  //     display:flex;
  //     align-items:center;
  //     position:absolute;
  //     top:50%;
  //     left:50%;
  //     transform:translate(-50%,-50%);
  //     width:200px;
  //     height:200px;
  //     color:white;
  //     background-color:pink;
  //     z-index:13;          `
  // )
  // div.innerHTML = '资源有更新，请刷新以获取最新的服务信息，双击关闭'
  // document.body.appendChild(div)
  // div.addEventListener('dblclick',()=>{
  //   document.body.removeChild(div)
  // })
}
